import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Paper, MenuList, Slide } from "@mui/material";
import { RouteTypes } from "../../../Enums/RouteTypes";
import {
  CheckAllRights,
  CheckAllRoles,
  CheckMultiRightsForClient,
  CheckRightsForClient,
  CheckRoleForClient,
  CheckCrmUserManagementRoleForClient,
} from "../../../Helpers/PermissionsChecks";
import { useSelector } from "react-redux";
import { selectUserPermissionsValue } from "../../../State/Slices/UserPermissionsSlice";
import { selectClientValue } from "../../../State/Slices/SelectedClientSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      zIndex: "5",
      left: "95px",
    },
    height: "100vh",
    background: "#fafafa",
    justifyContent: "right",
    boxShadow: "0px 0px 5px darkgrey",
    display: "flex",
  },
  list: {
    padding: "10px",
  },
}));

function checkRouteAccess(
  rolesObject,
  baseClientId,
  routeType,
  requiredPermissions
) {
  switch (routeType) {
    case RouteTypes.Unprotected:
      return true;
    case RouteTypes.RoleProtected:
      return CheckAllRoles(rolesObject, requiredPermissions);
    case RouteTypes.ClientRoleProtected:
      return CheckRoleForClient(rolesObject, baseClientId, requiredPermissions);
    case RouteTypes.RightProtected:
      return CheckAllRights(rolesObject, requiredPermissions);
    case RouteTypes.ClientRightProtected:
      return CheckRightsForClient(
        rolesObject,
        baseClientId,
        requiredPermissions
      );
    case RouteTypes.ClientRightsProtected:
      return CheckMultiRightsForClient(
        rolesObject,
        baseClientId,
        requiredPermissions
      );
    case RouteTypes.ClientCrmRightsProtected:
      return (
        CheckCrmUserManagementRoleForClient(rolesObject, baseClientId) ||
        CheckRightsForClient(rolesObject, baseClientId, requiredPermissions)
      );
    default:
      return false;
  }
}

export default function SubMenu(props) {
  const classes = useStyles();
  const [hasRouteAccess, setHasRouteAccess] = useState(false);
  const rolesObject = useSelector(selectUserPermissionsValue);
  const selectedClient = useSelector(selectClientValue);

  useEffect(() => {
    setHasRouteAccess(
      checkRouteAccess(
        rolesObject,
        selectedClient.id?.toUpperCase(),
        props.routeType,
        props.requiredPermissions
      )
    );
  }, [
    props.navMenuSelection,
    props.menuCategory,
    rolesObject,
    selectedClient,
    props.routeType,
    props.requiredPermissions,
  ]);

  if (props.index === props.selected && hasRouteAccess) {
    return (
      <Slide direction="right" in={props.open} mountOnEnter unmountOnExit>
        <Paper elevation={1} square className={classes.root}>
          <MenuList className={classes.list}>{props.children}</MenuList>
        </Paper>
      </Slide>
    );
  }
  return null;
}
